import { Flex, FlexProps } from "@chakra-ui/react";
import { HorizontalGreyBlackField } from "components/DataDisplay/GreyBlackField";
import IssueExclamation from "components/Icon/Iconify/IssueExclamation";
import { ActionV2 } from "features/Resources/Shared/models";
import { useIssuesByActionPrefixIdQuery, usePendingIssuesByActionPrefixIdQuery } from "features/Issues/hooks";
import { useActionDetailQueryByPrefixId } from "features/Resources/Shared/hooks";
import { longAttributeStyles } from "components/DataDisplay/styles";
import { Issue } from "models/issue";
import { ListActionIssues } from ".";

interface BaseIssuesByActionProps extends FlexProps {
  action: ActionV2;
  issues: Issue[];
  fieldProps?: object;
}

export function BaseIssuesByAction({ issues, action, fieldProps = {}, ...rest }: BaseIssuesByActionProps) {
  const numberOfIssues = issues?.length || 0;
  if (!issues?.length) return null;
  return (
    <Flex gap="2" mt="3" {...rest}>
      <HorizontalGreyBlackField
        icon={IssueExclamation}
        label={`${numberOfIssues} Issue${numberOfIssues > 1 ? "s" : ""}`}
        labelContainerProps={{ minWidth: "75px", ...longAttributeStyles.labelContainerProps }}
        align="flex-start"
        {...fieldProps}
      >
        <ListActionIssues issues={issues} action={action} />
      </HorizontalGreyBlackField>
    </Flex>
  );
}

interface ListIssuesByActionProps extends FlexProps {
  prefixId: ActionV2["prefixId"];
  fieldProps?: object;
}

export function ListIssuesByAction({ prefixId, fieldProps = {}, ...rest }: ListIssuesByActionProps) {
  const { data: issues = [] } = useIssuesByActionPrefixIdQuery(prefixId, { enabled: !!prefixId });
  const { data: action } = useActionDetailQueryByPrefixId(prefixId, { enabled: !!prefixId });

  if (!issues?.length || !action) return null;

  return <BaseIssuesByAction action={action} issues={issues} {...rest} />;
}

export function ListIssuesByActionDuringPending({ prefixId, fieldProps = {}, ...rest }: ListIssuesByActionProps) {
  const { data: issues = [] } = usePendingIssuesByActionPrefixIdQuery(prefixId);
  const { data: action } = useActionDetailQueryByPrefixId(prefixId, { enabled: !!prefixId });

  if (!issues?.length || !action) return null;

  return <BaseIssuesByAction action={action} issues={issues} {...rest} />;
}
